import Client from './client';

export default class Memberships extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postAcceptAndAll(options = {}) {
    return this.makeRequest(`${this.host}/internal/invitations/accept/all`, {
      ...options,
       method: 'POST',
    });
  }

}
